/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AccountIdFilters } from '../models/AccountIdFilters';
import { IdFilters } from '../models/IdFilters';
import { InitiatorNameFilters } from '../models/InitiatorNameFilters';
import { JobIdFilters } from '../models/JobIdFilters';
import { JobStatusFilters } from '../models/JobStatusFilters';
import { ResourceIdFilters } from '../models/ResourceIdFilters';
import { ResourceNameFilters } from '../models/ResourceNameFilters';
import { ResourceTypeFilters } from '../models/ResourceTypeFilters';
import { RestoreJobTypeFilters } from '../models/RestoreJobTypeFilters';
import { SnapshotIdFilters } from '../models/SnapshotIdFilters';

/**
* Filter conditions. If omitted, no filtering is applied. 
*/
export class RestoreJobsFilterConditions {
  'id'?: IdFilters;
  'jobId'?: JobIdFilters;
  'snapshotId'?: SnapshotIdFilters;
  'status'?: JobStatusFilters;
  'providerResourceId'?: ResourceIdFilters;
  'restoreType'?: RestoreJobTypeFilters;
  'vaultId'?: IdFilters;
  'resourceType'?: ResourceTypeFilters;
  'providerAccountId'?: AccountIdFilters;
  'resourceName'?: ResourceNameFilters;
  'internalResourceId'?: IdFilters;
  'initiatorName'?: InitiatorNameFilters;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "IdFilters",
      "format": ""
    },
    {
      "name": "jobId",
      "baseName": "jobId",
      "type": "JobIdFilters",
      "format": ""
    },
    {
      "name": "snapshotId",
      "baseName": "snapshotId",
      "type": "SnapshotIdFilters",
      "format": ""
    },
    {
      "name": "status",
      "baseName": "status",
      "type": "JobStatusFilters",
      "format": ""
    },
    {
      "name": "providerResourceId",
      "baseName": "providerResourceId",
      "type": "ResourceIdFilters",
      "format": ""
    },
    {
      "name": "restoreType",
      "baseName": "restoreType",
      "type": "RestoreJobTypeFilters",
      "format": ""
    },
    {
      "name": "vaultId",
      "baseName": "vaultId",
      "type": "IdFilters",
      "format": ""
    },
    {
      "name": "resourceType",
      "baseName": "resourceType",
      "type": "ResourceTypeFilters",
      "format": ""
    },
    {
      "name": "providerAccountId",
      "baseName": "providerAccountId",
      "type": "AccountIdFilters",
      "format": ""
    },
    {
      "name": "resourceName",
      "baseName": "resourceName",
      "type": "ResourceNameFilters",
      "format": ""
    },
    {
      "name": "internalResourceId",
      "baseName": "internalResourceId",
      "type": "IdFilters",
      "format": ""
    },
    {
      "name": "initiatorName",
      "baseName": "initiatorName",
      "type": "InitiatorNameFilters",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreJobsFilterConditions.attributeTypeMap;
  }

  public constructor() {
  }
}

